import AccountTreeIcon from "@mui/icons-material/AccountTree";
import { SxProps } from "@mui/material";

import { FilterDropdown, type FilterOption } from "./FilterDropdown";

// Source filter types - keeping the original types for backward compatibility
export type SourceFilterType = "All" | "User" | "Trigger";

interface InvocationSourceFilterProps {
  selectedSources: string[];
  onSourceChange: (sources: string[]) => void;
  sx?: SxProps;
}

const SOURCE_OPTIONS: FilterOption[] = [
  { value: "User", label: "User" },
  { value: "Trigger", label: "Trigger" },
];

export default function InvocationSourceFilter({
  selectedSources,
  onSourceChange,
  sx,
}: InvocationSourceFilterProps) {
  return (
    <FilterDropdown
      options={SOURCE_OPTIONS}
      selectedValues={selectedSources}
      onChange={onSourceChange}
      buttonTitle="Source"
      title="Filter by Source"
      buttonIcon={<AccountTreeIcon />}
      sx={sx}
      testId="source-filter"
    />
  );
}
